import React from 'react';
import PropTypes from 'prop-types';
import { Comment } from 'semantic-ui-react';
import FlipMove from 'react-flip-move';
import { FlashIndicator } from '../../.././../../components';
import AnswerComment from '../Comment';

const Comments = ({
    comments,
    lastUpdatedCommentId,
    clearUpdatedComment,
}) => (
    <Comment.Group>
        <FlipMove
            duration={500}
            easing="ease-in"
            typeName={null}
        >
            {comments.map(({
                id: cId,
                createdByUser: {
                    id: createdById,
                    ...createdByUser
                },
                ...comment
            }) => (
                <FlashIndicator
                    active={cId === lastUpdatedCommentId}
                    key={cId}
                    makeInactive={clearUpdatedComment}
                    activeClass="highlighted"
                    inactiveClass="inactive"
                >
                    <AnswerComment
                        id={cId}
                        {...comment}
                        createdByUser={{
                            ...createdByUser,
                            id: createdById,
                        }}
                    />
                </FlashIndicator>
            ))}
        </FlipMove>
    </Comment.Group>);

Comments.propTypes = {
    comments: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    lastUpdatedCommentId: PropTypes.number,
    clearUpdatedComment: PropTypes.func.isRequired,
};

Comments.defaultProps = {
    lastUpdatedCommentId: null,
};

export default Comments;
